module.exports = __webpack_public_path__ + "static/media/calender-dark.b22edf36.png";